export default __webpack_public_path__ + "static/persons-feature-flag-tab-dark-mode-e7c4e7f4d2f5d5295918520b92b7dde3.png";